import { render, staticRenderFns } from "./RequestAddProductsComponent.vue?vue&type=template&id=78a65d9c"
import script from "./RequestAddProductsComponent.vue?vue&type=script&lang=js"
export * from "./RequestAddProductsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports